/**
 * App shell URL prefix (matches Router basename and server deploy path).
 */
export const getAppBasePath = () => {
  const publicUrl = process.env.PUBLIC_URL || "";
  const trimmed = publicUrl.replace(/\/$/, "");
  if (trimmed && trimmed !== ".") {
    return trimmed;
  }
  return "/admin";
};

export const getAppAssetUrl = (relativePath) => {
  const path = relativePath.startsWith("/") ? relativePath : `/${relativePath}`;
  return `${getAppBasePath()}${path}`;
};
